interface Props {
  size?: number;
  color?: string;
}

const CloseIcon = (props: Props) => {
  const { color = '#000', size = 16 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27933 11.8718C2.90689 12.2442 2.90689 12.8481 3.27933 13.2205C3.65177 13.593 4.25561 13.593 4.62805 13.2205L7.99994 9.84861L11.3719 13.2207C11.7444 13.5931 12.3482 13.5931 12.7207 13.2207C13.0931 12.8482 13.0931 12.2444 12.7207 11.8719L9.34866 8.49986L12.7204 5.12808C13.0928 4.75563 13.0928 4.15178 12.7204 3.77933C12.348 3.40689 11.7441 3.40689 11.3717 3.77933L7.99994 7.15112L4.62833 3.77946C4.25589 3.40702 3.65205 3.40702 3.27961 3.77946C2.90717 4.15191 2.90717 4.75576 3.27961 5.12821L6.65121 8.49986L3.27933 11.8718Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
